import type { PortfolioVideo } from '../types/portfolio';

export const portfolioVideos: PortfolioVideo[] = [
  {
    "id": "4ab1e772-2b0e-42e9-9410-b3dce186fd98",
    "video_id": "QlbO0LmuKXI",
    "description": "Editor",
    "tag": "Reaction",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "a246155b-9add-4721-a8c3-3913eba3fcc3",
    "video_id": "DGzcJor6__4",
    "description": "Editor",
    "tag": "Podcast",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "3a85878c-34de-404e-8fba-fe104d413274",
    "video_id": "Jdmw9lm5hUA",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "9c264bcd-99f9-4440-b652-e5d671af2f5d",
    "video_id": "VHlZZPmE3IA",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "27c0aed3-b767-4289-9828-0b4da76dc8f1",
    "video_id": "YAOkrN9Bg20",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "5cfc6a0f-4192-4ab8-956c-06e44b47dfb8",
    "video_id": "2cChmdNe11Y",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "395ea788-606c-4d88-a318-d4ceaef69aaf",
    "video_id": "fJcda05kFQE",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "1b893272-7fa5-45c7-a88a-06663b5e21ac",
    "video_id": "SRvJDrsEPRU",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "edc642b4-9798-4a96-b9fa-69293234f329",
    "video_id": "K3kKSa6Se5U",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "4220c864-eb0d-46b9-abfb-bb7610f0f44a",
    "video_id": "vFTd5QLv-vg",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "ce004b53-962f-4bed-9154-b3e8e1425121",
    "video_id": "gFwGPDadWCQ",
    "description": "Editor",
    "tag": "Commentary",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "45168ea2-c36c-4c92-a098-74092485de71",
    "video_id": "FmqJNmo6p_g",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "64200dc1-6ba4-4e5c-82f7-9bed11159572",
    "video_id": "AEe-og2l2R4",
    "description": "Editor",
    "tag": "Reaction",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "6fdb7eb6-0495-4e75-90f6-fe4a1b9ae8e5",
    "video_id": "pbPG_Wnhevc",
    "description": "Editor",
    "tag": "Commentary",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "7ac4d3af-5f53-405f-973e-ac1219aef262",
    "video_id": "sSM5eN1KupA",
    "description": "Editor",
    "tag": "Reaction",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "8d329fc6-5151-42a3-94d4-29ed3043dc8c",
    "video_id": "buAcXG9f-AA",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "c0357a7b-2189-4a0c-bd1e-5570a5a501e3",
    "video_id": "r-i_YiuoXLM",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "2c1ac1f9-b950-4f76-8d4f-b298b70ea8c0",
    "video_id": "tDTCJmTdXc8",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "edcfa4cf-ec30-4887-9bda-62c1a925c0cf",
    "video_id": "aR6nqytYGXo",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "6d98ceba-8aa9-4352-aa6e-406bf2514fae",
    "video_id": "cVRuLaEJij0",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-25T14:57:18.549711+00:00"
  },
  {
    "id": "8aee0a44-5e22-4220-a2e7-aeb2fe923d1b",
    "video_id": "6u1uT3yeO34",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-21T18:03:26.319877+00:00"
  },
  {
    "id": "9bf13d99-2b43-49f0-9071-35e5a6538f20",
    "video_id": "n4JXO6EGh9c",
    "description": "Editor",
    "tag": "Reaction",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "7f017633-47ba-4633-a090-31b86198addc",
    "video_id": "3aUtYVr62lw",
    "description": "Editor",
    "tag": "Interview",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "34262b6b-894c-4f68-af3e-740aac0432cd",
    "video_id": "mxapaXrHr1Y",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "bfc21c09-8b74-4bae-b188-3d793124c09e",
    "video_id": "hv48O6Pngtk",
    "description": "Editor",
    "tag": "Reaction",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "37a4d33f-4d77-4974-8a2b-9f39a937e82a",
    "video_id": "mMMQYz_vJFw",
    "description": "Editor",
    "tag": "Podcast",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "262d9de1-b721-4726-b4d3-3db1b6e38ded",
    "video_id": "qWRxeOZz5L0",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-07-21T18:00:35.220999+00:00"
  },
  {
    "id": "0c287d9a-5385-4ffe-96c0-ae2b7ad1e405",
    "video_id": "sb1Zg1hAHgk",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-03-01T03:31:12.59519+00:00"
  },
  {
    "id": "001cd5fd-431a-4729-a1b8-bbb704bf54ef",
    "video_id": "gWNuS0tRVbY",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-03-01T03:31:12.59519+00:00"
  },
  {
    "id": "40d35612-547c-474c-9ec2-6d147c4946e2",
    "video_id": "PQu1n_OC1eE",
    "description": "Editor",
    "tag": "Documentary",
    "created_at": "2026-03-01T03:31:12.59519+00:00"
  },
  {
    "id": "3f9b8386-4009-42f7-9731-f8fcb0e8c169",
    "video_id": "JACxe2Z0wcI",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2024-11-16T16:29:36+00:00"
  },
  {
    "id": "65b127bb-7e52-4ef2-8df9-bb58ae806925",
    "video_id": "J6-iOtGNWBQ",
    "description": "Editor",
    "tag": "Commentary",
    "created_at": "2024-11-14T17:29:36.142151+00:00"
  },
  {
    "id": "6a4ca536-8f74-48ed-945c-1711a2869cd7",
    "video_id": "ZTJfuPBCoKo",
    "description": "Editor, Colorist",
    "tag": "Podcast",
    "created_at": "2024-11-14T17:29:36.142151+00:00"
  },
  {
    "id": "b4e7e16c-deca-47b6-8e5e-695309cfcad6",
    "video_id": "D6ThvooDfbA",
    "description": "Videographer, Editor",
    "tag": "Podcast",
    "created_at": "2024-11-14T17:29:36.142151+00:00"
  },
  {
    "id": "e73d18cf-ef23-40a2-a7ae-e852c2872749",
    "video_id": "QmVzp5z0C6A",
    "description": "Videographer, Editor",
    "tag": "Commercial",
    "created_at": "2024-11-14T17:29:36.142151+00:00"
  },
  {
    "id": "735b8be9-1597-4980-9a31-14213b32eae7",
    "video_id": "iu6Hv-27MRQ",
    "description": "Editor",
    "tag": "Commentary",
    "created_at": "2024-11-14T17:29:36.142151+00:00"
  },
  {
    "id": "8888376c-a846-4bec-8d1e-b5d91408ba78",
    "video_id": "eNPZxieTHfI",
    "description": "Editor, Colorist, Sound Mixer",
    "tag": "Short Film",
    "created_at": "2024-11-13T02:53:07.042819+00:00"
  },
  {
    "id": "f9882222-6f56-413d-8796-4af54108d971",
    "video_id": "YBUwRg83oqA",
    "description": "Editor, Colorist, Sound Mixer",
    "tag": "Short Film",
    "created_at": "2024-11-12T19:54:40.216734+00:00"
  },
  {
    "id": "2a73b52a-c47a-4726-a1b6-5449e9af4b8c",
    "video_id": "O_K5aX9wDvE",
    "description": "Editor, Colorist, Sound Mixer",
    "tag": "Short Film",
    "created_at": "2024-10-16T14:53:07+00:00"
  },
  {
    "id": "620a9c85-6296-4bc1-99dc-aab2d88ff274",
    "video_id": "PLeUhJii6Zk",
    "description": "Editor",
    "tag": "Explainer",
    "created_at": "2024-03-01T03:31:12.59519+00:00"
  },
  {
    "id": "8c229d4f-303a-4b04-8204-eeef94f44c0e",
    "video_id": "QPRYfLCxA1g",
    "description": "Editor",
    "tag": "Highlights",
    "created_at": "2023-11-16T17:29:36+00:00"
  }
];
